import EventDetailValuationBlock from './EventDetailValuationBlock';
import ModalCerfa from './modal-cerfa';
import ModalContract from './modal-contract';
import ModalEdit from './modal-edit';

export default EventDetailValuationBlock;

export { ModalCerfa, ModalContract, ModalEdit };
